import React, { Component } from 'react';
import Img from 'gatsby-image';
import PropTypes from 'prop-types';
import { IconSVG } from '..';
import { getImageAlt } from 'config/helpers';
import './Image.scss';

class Image extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isImageLoaded: false,
    };
  }

  componentDidMount() {
    // Due to service worker issue, first time images could not trigger onLoad function
    setTimeout(this.triggerEmergencyPlaceholderHide, 3000);
  }

  triggerEmergencyPlaceholderHide = () => {
    this.setState({ isImageLoaded: true });
  };

  handleImageOnLoad = () => {
    this.setState({ isImageLoaded: true });
  };

  renderSimpleImage = () => {
    const { src, alt, additionalClass, placeholder, style } = this.props;

    return !placeholder ? (
      <img
        src={src}
        className={`image ${additionalClass}`}
        alt={alt || getImageAlt(src)}
        title={alt || getImageAlt(src)}
      />
    ) : (
      <div className={'image__wrapper image--normal'}>
        <img
          src={src}
          className={`image ${additionalClass} ${
            this.state.isImageLoaded ? 'image--loaded' : ''
          }`}
          alt={alt || getImageAlt(src)}
          title={alt || getImageAlt(src)}
          onLoad={this.handleImageOnLoad}
        />
        {!this.state.isImageLoaded && (
          <div className={'image__placeholder'}>
            <IconSVG name={'image-loading'} color={'gray'} />
          </div>
        )}
      </div>
    );
  };

  render() {
    const { src, alt, additionalClass, style, type } = this.props;

    return typeof src === 'object' ? (
      <Img
        {...{ [type]: src }}
        imgStyle={
          style ||
          (type === 'fluid'
            ? {
                width: '100%',
                height: '100%',
              }
            : {})
        }
        alt={alt || getImageAlt(src.originalName || src.src)}
        title={alt || getImageAlt(src.originalName || src.src)}
        className={`image image--optimized ${additionalClass}`}
        outerWrapperClassName={'image__wrapper--optimized'}
      />
    ) : (
      this.renderSimpleImage()
    );
  }
}

Image.defaultProps = {
  additionalClass: '',
  alt: '',
  placeholder: false,
  style: null,
  type: 'fluid',
};

Image.propTypes = {
  src: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  alt: PropTypes.string,
  placeholder: PropTypes.bool,
  additionalClass: PropTypes.string,
  style: PropTypes.shape(),
  type: PropTypes.string,
};

export default Image;
